import React from 'react'

type Props = {}

const Notice = (props: Props) => {
    return (
        <div>
            
        </div>
    )
}

export default Notice